import validateEmail from 'utils/validateEmail';

/**
 * Check Valid Email
 * @param {String} email
 * @return {String}
*/
const checkValidEmail = (email) => {
  if (email && !validateEmail(email)) {
    return 'invalidEmail';
  }
  return '';
};

export default checkValidEmail;